// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://unpkg.com/video.js/dist/video-js.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-0aae13fa] .vjs-play-progress{background:var(--v-accentPurpleAccessible-base)}.video-container[data-v-0aae13fa]{margin:0 auto;max-width:100%;padding-top:56.25%;position:relative;width:100%}.video-js[data-v-0aae13fa],.vjs-fluid[data-v-0aae13fa]{height:100%;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
